import React from 'react';
import { clarityEvent } from '../utils/clarity';
import { PRIMARY_PHONE, PRIMARY_PHONE_DISPLAY } from '../constants/stores';

/**
 * ErrorBoundary – render-hiba esetén NEM fehér képernyő, hanem
 * márka-konzisztens fallback CTA-val (a hívás konverzió hiba esetén is él).
 * A hibát GA4 `exception` eseményként riportolja (Error monitoring – P3.8):
 * GA4-ben az exception → description/fatal mezőkkel szűrhető.
 */
export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    try {
      if (window.gtag) {
        window.gtag('event', 'exception', {
          description: `${error?.message || 'render error'} @ ${this.props.name || 'app'}`,
          fatal: true,
        });
      }
    } catch (e) { /* a riport sosem dobhat tovább */ }
    clarityEvent('ErrorBoundary_Shown');
    // Konzolba is – Sentry/log-gyűjtő később innen tudja felvenni
    console.error('[ErrorBoundary]', this.props.name || 'app', error, info?.componentStack);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="min-h-[50vh] flex items-center justify-center px-4">
          <div className="max-w-md text-center py-16">
            <p className="text-5xl mb-4" aria-hidden="true">😵</p>
            <h1 className="text-2xl font-bold text-ink mb-2">Hoppá, valami elromlott.</h1>
            <p className="text-gray-600 mb-6">
              Frissítsd az oldalt, vagy hívj minket – személyesen biztosan tudunk segíteni.
            </p>
            <div className="flex flex-col sm:flex-row gap-3 justify-center">
              <a
                href={`tel:${PRIMARY_PHONE}`}
                className="inline-flex items-center justify-center px-6 py-3 bg-brand text-white font-semibold rounded-full hover:bg-brand-hover transition-colors"
              >
                Hívás: {PRIMARY_PHONE_DISPLAY}
              </a>
              <button
                type="button"
                onClick={() => window.location.reload()}
                className="inline-flex items-center justify-center px-6 py-3 bg-white text-ink font-semibold rounded-full border-2 border-gray-200 hover:bg-gray-50 transition-colors"
              >
                Oldal újratöltése
              </button>
            </div>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}
